import { Dict } from "mixpanel-browser"

export enum AnalyticsEvents {
  starter_promo_selected = "starter_promo_selected",
  ttv_started = "ttv_started",
  avatar_creation_started = "avatar_creation_started",
  ttv_process_cancelled = "ttv_process_cancelled",
  process_cancelled = "process_cancelled",
  avatar_process_cancelled = "avatar_process_cancelled",
  avatar_selected = "avatar_selected",
  preview_requested = "preview_requested",
  videos_requested = "videos_requested",
  video_requested = "video_requested",
  avatar_requested = "avatar_requested",
  payment_requested = "payment_requested",
  payment_provided = "payment_provided",
  video_creation_started = "video_creation_started",
  avatar_processing_started = "avatar_processing_started",
  training_video_uploaded = "training_video_uploaded",
  avatar_generation_requested = "avatar_generation_requested",
  consent_shown = "consent_shown",
  consent_provided = "consent_provided",
  knowledge_file_uploaded = "knowledge_file_uploaded",
  create_agent_started = "create_agent_started",
  agent_info_provided = "agent_info_provided",
  agent_training_started = "agent_training_started",
  agent_created = "agent_created",
  agent_creation_failed = "agent_creation_failed",
  feedback_initiated = "feedback_initiated",
  feedback_submitted = "feedback_submitted",
  feedback_submission_failed = "feedback_submission_failed",
  api_key_created = "api_key_created",
  api_key_creation_failed = "api_key_creation_failed",
  api_key_copied = "api_key_copied",
  api_key_copied_failed = "api_key_copied_failed",
  upgrade_subscription_clicked = "upgrade_subscription_clicked",
  manage_billing_clicked = "manage_billing_clicked",
  manage_billing_failed = "manage_billing_failed",
  subscription_upgraded = "subscription_upgraded",
  subscription_downgraded = "subscription_downgraded",
  subscription_processing_failed = "subscription_processing_failed",
  signed_in_email = "signed_in_email",
  signed_in_email_failed = "signed_in_email_failed",
  signed_up_email = "signed_up_email",
  signed_up_email_failed = "signed_up_email_failed",
  signed_in_google = "signed_in_google",
  signed_in_google_failed = "signed_in_google_failed",
  signed_up_google = "signed_up_google",
  signed_up_google_failed = "signed_up_google_failed",
  message_reaction = "message_reaction",
}

export enum AnalyticsProducts {
  text_to_video = "text_to_video",
  avatar_creation = "avatar_creation",
  agent_creation = "agent_creation",
  api_key = "api_key",
  subscription = "subscription",
  app = "app",
  auth = "auth",
}

export enum AnalyticsProperties {
  product = "product",
  numberOfVideos = "Number of videos",
  amount = "amount",
}

export type AnalyticsDict =
  | Dict
  | Partial<Record<keyof typeof AnalyticsProperties, string | number>>

export interface DailyUsage {
  date: string
  minutes: number
}

export interface Analytics {
  billing_cycle: {
    start_date: string | null
    end_date: string | null
    billing_frequency_months: number
  }
  total_minutes: number
  daily_usage: DailyUsage[]
}

export interface ChartDataPoint {
  date: Date
  value: number
}

export interface ChartStats {
  total: number
  avg: number
  peak: number
}
